/**
 * Adapter lưu trữ ngoài core: localStorage + tự lưu 30 giây.
 *
 * Core (src/core/luu-tru.ts) chỉ có hàm thuần; lớp này nối vào Storage
 * được inject (localStorage trên browser, fake trong test).
 * UI (M2) dùng lớp này; sim/test dùng hàm thuần của core.
 */
import { nhapJson, taoBanLuu, xuatJson } from './core/luu-tru.js';
import type { TrangThaiGame } from './core/types.js';

/** Tối thiểu hóa interface Storage để dễ inject trong test. */
export interface BoNhoLuuTru {
  getItem(khoa: string): string | null;
  setItem(khoa: string, giaTri: string): void;
  removeItem(khoa: string): void;
}

export class LuuTruTuDong {
  private readonly boNho: BoNhoLuuTru;
  private readonly khoa: string;
  private readonly chuKyMs: number;
  private idHenGio: ReturnType<typeof setInterval> | null = null;
  private layState: (() => TrangThaiGame) | null = null;

  constructor(boNho: BoNhoLuuTru, khoa = 'idle-shop-save', chuKyMs = 30_000) {
    this.boNho = boNho;
    this.khoa = khoa;
    this.chuKyMs = chuKyMs;
  }

  /** Lưu ngay state hiện tại. */
  luu(state: TrangThaiGame): void {
    this.boNho.setItem(this.khoa, xuatJson(state));
  }

  /** Tải bản lưu; null nếu chưa có. Ném lỗi nếu bản lưu hỏng. */
  tai(): TrangThaiGame | null {
    const raw = this.boNho.getItem(this.khoa);
    if (raw === null) return null;
    return nhapJson(raw);
  }

  /** Xóa bản lưu (dùng sau xác nhận hai bước ở UI). */
  xoa(): void {
    this.boNho.removeItem(this.khoa);
  }

  /** Bắt đầu tự lưu định kỳ — gọi layState() mỗi chu kỳ. */
  batDauTuDong(layState: () => TrangThaiGame): void {
    this.dungTuDong();
    this.layState = layState;
    this.idHenGio = setInterval(() => {
      const lay = this.layState;
      if (lay) this.luu(lay());
    }, this.chuKyMs);
  }

  /** Dừng tự lưu (khi thoát game / unmount). */
  dungTuDong(): void {
    if (this.idHenGio !== null) {
      clearInterval(this.idHenGio);
      this.idHenGio = null;
    }
    this.layState = null;
  }

  /** Xuất chuỗi JSON để người chơi copy/tải file. */
  xuat(state: TrangThaiGame): string {
    return xuatJson(state);
  }

  /** Nhập từ chuỗi JSON (ghi đè bản lưu hiện tại). */
  nhap(json: string): TrangThaiGame {
    const state = nhapJson(json);
    this.boNho.setItem(this.khoa, JSON.stringify(taoBanLuu(state)));
    return state;
  }
}
